import { readConsent } from "../../utils/consent";
import { toolDefinitions } from "../tools/registry";
import type { ToolId } from "./types";
export type ToolExperienceEvent =
  | "tool_viewed"
  | "primary_action_opened"
  | "work_opened"
  | "filter_applied"
  | "tool_discovered"
  | "task_submitted";
export interface ToolExperienceDetail {
  toolId: ToolId;
  source: "page" | "home" | "catalog" | "command";
  layout: "phone" | "desktop";
  elapsedMs?: number;
  scrollBucket?: "none" | "one-screen" | "multiple-screens";
}
export const deviceLayout = () =>
  window.innerWidth <= 768 ? ("phone" as const) : ("desktop" as const);
export function trackToolExperience(
  event: ToolExperienceEvent,
  detail: ToolExperienceDetail,
): void {
  if (
    readConsent()?.analytics_storage !== "granted" ||
    ![
      "tool_viewed",
      "primary_action_opened",
      "work_opened",
      "filter_applied",
      "tool_discovered",
      "task_submitted",
    ].includes(event) ||
    !toolDefinitions.some((t) => t.id === detail.toolId) ||
    !["page", "home", "catalog", "command"].includes(detail.source) ||
    !["phone", "desktop"].includes(detail.layout)
  )
    return;
  const target = window as typeof window & {
    dataLayer?: Record<string, unknown>[];
  };
  const payload: Record<string, unknown> = {
    event: `ux_${event}`,
    tool: detail.toolId,
    source: detail.source,
    layout: detail.layout,
  };
  if (typeof detail.elapsedMs === "number" && Number.isFinite(detail.elapsedMs))
    payload.elapsed_ms = Math.round(
      Math.max(0, Math.min(detail.elapsedMs, 86_400_000)),
    );
  if (
    detail.scrollBucket &&
    ["none", "one-screen", "multiple-screens"].includes(detail.scrollBucket)
  )
    payload.scroll_bucket = detail.scrollBucket;
  target.dataLayer ||= [];
  target.dataLayer.push(payload);
}
